module.exports = __webpack_public_path__ + "img/okcupidc.91ca376.png";